import { useCallback } from "react";
import { useRequest } from "@danishagro/shared/src/hooks/useRequest.hook";
import { FetchOptions } from "@danishagro/shared/src/interfaces/fetchOptions.interface";

type AcceptPrivatePolicy = (options?: FetchOptions) => Promise<Response>;

export const usePrivacyPolicyApi = () => {
    const request = useRequest();

    const acceptPrivatePolicy: AcceptPrivatePolicy = useCallback(
        (options) => request.post(`api/Consent/accept`, options),
        [request]
    );

    return {
        acceptPrivatePolicy,
    };
};
